import React from 'react';
import { Link } from 'react-router-dom';

const CategoryCard = ({ category }) => {
    return (
        <div className="category-card-wrapper mb-4">
            <Link to={`/productlist?category_id=${category.id}`} className="text-decoration-none">
                <div className="category-card glass-card hover-lift p-4 text-center position-relative overflow-hidden">
                    <div className="category-icon-3d mb-3">
                        <img
                            src={category.image}
                            alt={category.name || "Category"}
                            className="img-fluid"
                            loading="lazy"
                            width="90"
                            height="90"
                        />
                    </div>
                    <h6 className="font-heading text-uppercase fs-xs ls-1 text-dark mb-0">
                        {category.name}
                    </h6>

                    {/* Decorative Background Accent */}
                    <div className="card-accent"></div>
                </div>
            </Link>

            <style jsx="true">{`
                .category-card-wrapper {
                    perspective: 1000px;
                }
                
                .category-card {
                    height: 180px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    transition: var(--transition);
                    background: #fff;
                    border: none;
                    box-shadow: var(--shadow-soft);
                    border-radius: var(--radius-md);
                }
                
                .category-icon-3d {
                    position: relative;
                    z-index: 2;
                    transition: var(--transition);
                    width: 80px;
                    height: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                
                .category-icon-3d img {
                    max-width: 100%;
                    max-height: 100%;
                    filter: drop-shadow(0 10px 15px rgba(0,0,0,0.1));
                    transition: var(--transition);
                }
                
                .category-card:hover .category-icon-3d {
                    transform: translateY(-10px) scale(1.1) rotate(5deg);
                }
                
                .category-card:hover .category-icon-3d img {
                    filter: drop-shadow(0 15px 25px rgba(228, 0, 43, 0.2));
                }
                
                .card-accent {
                    position: absolute;
                    bottom: -20px;
                    right: -20px;
                    width: 80px;
                    height: 80px;
                    background: var(--primary);
                    opacity: 0.03;
                    border-radius: 50%;
                    transition: var(--transition);
                }
                
                .category-card:hover .card-accent {
                    transform: scale(3);
                    opacity: 0.05;
                }
                
                .category-card:hover h6 {
                    color: var(--primary) !important;
                }
            `}</style>
        </div>
    );
};

export default CategoryCard;
